import { Box, Typography } from "@mui/material";
import Lottie from "react-lottie";
import { assets } from "../../../../assets";
import { colors } from "@components/ui/colors";
import { useContactCenterTheme } from "../../theming/ContactCenterThemeContext";

export const SmsChatGreeting = () => {
  const { theme } = useContactCenterTheme();
  return (
    <Box
      sx={{
        flex: 1,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        p: 3,
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          width: "100%",
          maxWidth: 360,
          px: 3,
          py: 4,
          textAlign: "center",
          borderRadius: "16px",
          bgcolor: theme.shell.headerBg,
        }}
      >
        <Box
          sx={{
            height: 70,
            width: 70,

            overflow: "hidden",
            position: "relative",
          }}
        >
          <Box
            sx={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%) scale(2)", // ← crece el lottie
              transformOrigin: "center",
            }}
          >
            <Lottie
              options={{
                animationData: assets.animation.mesagge,
                loop: true,
              }}
              height={80}
              width={80}
            />
          </Box>
        </Box>

        {/* Title */}
        <Typography
          sx={{
            fontSize: 15,
            fontWeight: 600,
            color: "#F19531",
            letterSpacing: "-0.01em",
            marginTop: 2,
            mb: 1,
          }}
        >
          Welcome, Agent
        </Typography>

        {/* Subtitle */}
        <Typography
          sx={{
            fontSize: 13,
            lineHeight: 1.6,
            color: colors.gray[300],
            maxWidth: 240,
          }}
        >
          Select a contact or enter a number to start a new conversation.
        </Typography>

        {/* Accent line */}
        <Box
          sx={{
            mt: 3,
            width: 24,
            height: 2,
            borderRadius: 1,
            bgcolor: colors.orange[400],
            opacity: 0.35,
          }}
        />
      </Box>
    </Box>
  );
};
